import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import env from "../../env/env.json";
import ComponentList from "../../routes/ComponentList";
import { fetchXretry } from "../../services/fetchXretry";
import { getBase64 } from "../../services/getBase64";
import {
  checkEmailConfirmation,
  checkInputValidity,
  checkRadioGroup,
  checkRegexInputs,
  checkSelectGroup,
} from "../../utils/checkInputs";
import { handleResetFiles } from "../../utils/inputs";
import { scrollToReview, scrollToTop } from "../../utils/scrolling";
import Breadcrumb from "../layouts/Breadcrumb";
import NavigationButtons from "../layouts/NavigationButtons";

const FormulaireCU = ({ x_id_submit, TypeForm }) => {
  const [page, setPage] = useState(0);
  const [formData, setFormData] = useState({});
  const [professional, setProfessional] = useState({});
  const [professionals, setProfessionals] = useState([]);
  const [proprietaireIndivision, setProprietaireIndivision] = useState({});
  const [proprietairesIndivision, setProprietairesIndivision] = useState([]);
  const [signature, setSignature] = useState(null);
  const [tooltip, setTooltip] = useState(false);
  const [validResponse, setValidResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const sigRef = useRef();

  // ** const du fichier env.json */
  const environnement = env.environnement;
  const urlAPI = env[environnement];
  const ville = env.ville;
  const CP = env.CP;

  let files = {};
  let filesTest = false;

  // ** Permet la redirection vers la page de validation lorsque le formulaire est envoyé */
  const redirect = () => {
    nextPage();
  };

  const redirectTimeout = () => {
    setTimeout(function () {
      redirect();
    }, 1000);
  };

  //** Fonctions permettant de changer de page  */
  const preventPage = () => {
    if (page === 4 && validResponse === false) {
      setPage(2);
      scrollToTop();
    } else {
      setPage(page - 1);
      scrollToTop();
    }
  };

  const nextPage = () => {
    let hasError = false;
    let errorRadio = false;

    const inputs = document.querySelectorAll(".page-" + page + "-required");
    inputs.forEach((input) => {
      hasError = checkInputValidity(input) || hasError;
      errorRadio = checkRadioGroup(input) || errorRadio;
      hasError = checkSelectGroup(input) || hasError;
    });

    hasError = checkRegexInputs() || hasError;
    hasError = checkEmailConfirmation(page, formData) || hasError;
    scrollToReview();

    if (page === 2) {
      const inputsRenouvel = document.querySelectorAll(".renouvellement-group");
      if (
        formData.ProPremierCU === "Non" ||
        formData.ProActivite !==
          "Location meublée courte durée (location touristique)"
      ) {
        inputsRenouvel.forEach((input) => {
          input.value = "";
        });
        setFormData({
          ...formData,
          ProAutorisationPrec: "",
          nomTiers: "",
          prenomTiers: "",
        });
      }
      if (
        formData.ProPremierCU ===
          "Oui, je souhaite obtenir la reconduction de ma première autorisation pour 2 ans supplémentaires" &&
        validResponse === false
      ) {
        hasError = true;
        toast.error(
          "Votre renouvellement n'a pas été validé. Veuillez vérifier votre dossier"
        );
        inputsRenouvel.forEach((input) => {
          input.classList.add("is-invalid");
          scrollToReview();
        });
      } else {
        inputsRenouvel.forEach((input) => input.classList.remove("is-invalid"));
        setValidResponse(true);
      }
    }

    if (
      page === 2 &&
      formData.ProPremierCU ===
        "Oui, je souhaite obtenir la reconduction de ma première autorisation pour 2 ans supplémentaires" &&
      validResponse === true
    ) {
      setPage(4);
      scrollToTop();
      setValidResponse(false);
    } else if (!hasError && !errorRadio) {
      setPage(page + 1);
      scrollToTop();
    }

    // ** pour les tests et intégration manuelle, permet de passer les pages sans la gestion des erreurs */
    // setPage(page + 1);
    // scrollToTop();
  };

  //** Soumission du formulaire */
  const handleSubmit = () => {
    const sign = document.querySelector(".signatureCanva");
    let error = false;
    if (signature === null) {
      error = true;
      sign.classList.add("errorSignature");
      setTooltip(true);
    } else {
      sign.classList.remove("errorSignature");
      setTooltip(false);
    }
    if (!error) {
      document.querySelectorAll(".navigationBtn").forEach((btn) => {
        btn.classList.add("d-none");
      });
      const toastFetch = toast.loading(
        "Votre formulaire est en cours d'envoi..."
      );
      let myHeaders = {
        "Content-Type": "application/json",
      };
      getBase64().then((data) => {
        formData.PDF_CUCP = data;
        setFormData({ ...formData });
        let myInit = {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(formData),
          mode: "cors",
          cache: "default",
        };
        console.log(myInit);

        fetchXretry(urlAPI.path_form, myInit, 60000, 3)
          .then((response) => {
            console.log(response);
            try {
              return response.json();
            } catch (err) {
              return response;
            }
          })
          .then((result) => {
            if (
              (result.error !== undefined && result.error === "abort") ||
              result.msg === "Accès interdit"
            ) {
              console.log("erreur de transmission");
              toast.update(toastFetch, {
                render:
                  "La soumission de vos informations a échoué à plusieurs reprises, merci de contacter: support@touriz.fr",
                type: "error",
                isLoading: false,
                closeButton: true,
              });
            } else if (
              result.error !== undefined ||
              result.msg === "Accès interdit"
            ) {
              toast.update(toastFetch, {
                render:
                  "La soumission de vos informations a échoué, merci de contacter: support@touriz.fr ( " +
                  result.error +
                  " )",
                type: "error",
                isLoading: false,
                closeButton: true,
              });
            } else {
              console.log("Formulaire envoyé");
              // Simuler la progression
              let progress = 0;
              setTimeout(() => {
                const interval = setInterval(() => {
                  progress += 1;
                  toast.update(toastFetch, {
                    render: `Progression : ${progress}%`,
                    progress: progress / 100,
                  });
                  if (progress >= 100) {
                    clearInterval(interval);
                    toast.update(toastFetch, {
                      render: "Votre formulaire a bien été envoyé",
                    });
                    setTimeout(() => {
                      toast.dismiss(toastFetch);
                    }, 2000);
                    redirectTimeout();
                  }
                }, 40);
              }, 2000);
            }
          })
          .catch((reason) => {
            console.log(reason);
            toast.dismiss(toastFetch);
          })
          .catch((reason) => {
            console.log(reason);
            toast.dismiss(toastFetch);
          });
      });
    }
  };

  const componentListPage = ComponentList({
    formData,
    setFormData,
    professional,
    setProfessional,
    professionals,
    setProfessionals,
    proprietaireIndivision,
    setProprietaireIndivision,
    proprietairesIndivision,
    setProprietairesIndivision,
    ville,
    CP,
    page,
    setValidResponse,
    x_id_submit,
    TypeForm,
    files,
    filesTest,
    urlAPI,
    signature,
    setSignature,
    sigRef,
    tooltip,
    setTooltip,
    validResponse,
    setLoading,
    loading,
    toast,
  });

  const componentPage = componentListPage[page];

  return (
    <form
      id="myForm"
      className="form_container p-2 pb-5 p-md-5 pt-md-5 shadow needs-validation"
      noValidate
    >
      <input
        type="hidden"
        name="TypeForm"
        value={(formData["TypeForm"] = TypeForm)}
        id="TypeForm"
        readOnly
      />
      <input
        type="hidden"
        name="x-id-submit"
        value={(formData["x-id-submit"] = x_id_submit)}
        id="x-id-submit"
        readOnly
      />
      <Breadcrumb
        page={page}
        setPage={setPage}
        componentPage={componentPage}
        formData={formData}
      />
      {componentPage}

      {/* Conditions d'affichage des boutons en fonction de la page où l'on se trouve */}
      <NavigationButtons
        page={page}
        nextPage={nextPage}
        handleResetFiles={() =>
          handleResetFiles(
            x_id_submit,
            TypeForm,
            ville,
            urlAPI,
            files,
            setFormData,
            formData
          )
        }
        preventPage={preventPage}
        handleSubmit={handleSubmit}
        setPage={setPage}
        validResponse={validResponse}
      />
      {/* Permet de voir les données en temps réel */}
      {/* <pre className="pt-5 d-flex flex-column">
        <p>Visualisation de formData:</p>
        {JSON.stringify(formData, null, 2)}
      </pre> */}
    </form>
  );
};

export default FormulaireCU;
